module.exports = __webpack_public_path__ + "static/media/doc2.7b8d2f2b.svg";